import React, { useEffect, useRef, useState } from 'react';

const translateGoogleUnofficial = async (text, targetLang) => {
  try {
    const response = await fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=${targetLang}&dt=t&q=${encodeURIComponent(text)}`
    );
    const data = await response.json();
    return data[0][0][0];
  } catch (error) {
    console.error("Translation error:", error);
    return "Translation failed";
  }
};

const App = () => {
  const [original, setOriginal] = useState('');
  const [spanish, setSpanish] = useState('');
  const [portuguese, setPortuguese] = useState('');
  const [history, setHistory] = useState([]);
  const [listening, setListening] = useState(false);
  const recognitionRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert('Your browser does not support Speech Recognition. Try using Chrome.');
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = false;
    recognition.lang = 'en-US';

    recognition.onresult = async (event) => {
      const lastResultIndex = event.results.length - 1;
      const text = event.results[lastResultIndex][0].transcript;
      const es = await translateGoogleUnofficial(text, 'es');
      const pt = await translateGoogleUnofficial(text, 'pt');

      setOriginal(text);
      setSpanish(es);
      setPortuguese(pt);

      setHistory(prev => {
        const newEntry = { en: text, pt, es };
        const isDuplicate = prev.length > 0 &&
          prev[0].en === newEntry.en &&
          prev[0].pt === newEntry.pt &&
          prev[0].es === newEntry.es;
        return isDuplicate ? prev : [newEntry, ...prev.slice(0, 2)];
      });
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error:', event.error);
    };

    recognitionRef.current = recognition;

    return () => {
      recognition.stop();
      clearInterval(intervalRef.current);
    };
  }, []);

  const startListening = () => {
    if (!listening) {
      setListening(true);
      try {
        recognitionRef.current?.start();
      } catch (error) {
        console.warn('Start failed:', error.message);
      }

      intervalRef.current = setInterval(() => {
        try {
          recognitionRef.current?.start();
        } catch (e) {
          // already running
        }
      }, 5000);
    }
  };

  const stopListening = () => {
    setListening(false);
    recognitionRef.current?.stop();
    clearInterval(intervalRef.current);
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '700px', margin: 'auto' }}>
      <img src="/logo-language-lift.png" alt="Language Lift Logo" className="logo" />
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <button onClick={startListening} style={{ padding: '0.5rem 1.5rem', marginRight: '10px' }}>
          Start
        </button>
        <button onClick={stopListening} style={{ padding: '0.5rem 1.5rem', color: '#660000' }}>
          Stop
        </button>
      </div>
      <div style={{ marginTop: '2rem' }}>
        <p><strong>English:</strong> {original}</p>
        <p><strong>Portuguese:</strong> {portuguese}</p>
        <p><strong>Spanish:</strong> {spanish}</p>
        <ul>
          {history
            .filter(entry =>
              entry.en !== original ||
              entry.pt !== portuguese ||
              entry.es !== spanish
            )
            .map((entry, index) => (
              <li key={index}>
                <p><strong>EN:</strong> {entry.en}</p>
                <p><strong>PT:</strong> {entry.pt}</p>
                <p><strong>ES:</strong> {entry.es}</p>
              </li>
          ))}
        </ul>
      </div>
      <div className="footer">
        <a href="https://docs.google.com/document/d/1phTEIV2hxtazbmyzme5z-lLncaeY7g-UgcAEF-fSggY/edit?tab=t.0" target="_blank" rel="noopener noreferrer">
          User Guide & Terms of Service
        </a>
      </div>
    </div>
  );
};

export default App;